<template>
  <div class="right">
    <dv-border-box-10 >
      <div class="right-title">
        {{ name }}
      </div>
      <div class="right-content">
        <div class="right-content-item" style="height:24%;">
          <sub-infos :school-id="schoolId" />
        </div>
        <div class="right-content-item" style="height:33%;">
          <sub-course :school-id="schoolId" />
        </div>
        <div class="right-content-item" style="height:47%;">
          <sub-live :school-id="schoolId" />
        </div>
      </div>
    </dv-border-box-10>
  </div>
</template>

<script>
import subCourse from './subCourse'
import subInfos from './subInfos'
import subLive from './subLive'

export default {
  name: 'Right',
  components: {
    subInfos,
    subCourse,
    subLive
  },
  props: {
    schoolId: Number,
    name: String
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less">
.right {
    width: 32%;
    margin: 0.5%;
    background-color: rgba(6, 30, 93, 0.5);
    border-radius: 20px;
    display: flex;

    .right-title {
          padding: 10px 0%;
      height: 30px;
      line-height: 30px;
      font-size: 20px;
      width: 100%;
      text-align: center;
    }

    .right-content {
        width: 100%;
        height: calc(100% - 50px);
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .right-content-item {
      width: 90%;
      display: flex;
      justify-content: center;
    }

}
</style>
